import { FC } from 'react';

import config from '@ui-furniture/config';
import { ActiveCampaignTracking } from '@ui-furniture/ui/snippets/active-campaign-tracking';

export const ActiveCampaign: FC = () => (
  <ActiveCampaignTracking id={config.analytics.activeCampaignId} />
);
